import { Route } from "@angular/router";

import { authGuard } from "@core/guards/auth.guard";

import { OrganizationRoutesConstants } from "./organization.routes.constants";

export const organizationAdminRoutes: Route = {
  path: "organization",
  canActivate: [authGuard],
  children: [
    {
      path: OrganizationRoutesConstants.MY_ORGANIZATION,
      loadComponent: () =>
        import("../components/my-organization/my-organization.component").then((m) => m.MyOrganizationComponent),
      title: "My Organization"
    },
    {
      path: OrganizationRoutesConstants.USERS,
      loadComponent: () => import("../../admin/components/users/users.component").then((m) => m.UsersComponent),
      title: "Users"
    },
    {
      path: OrganizationRoutesConstants.AI_USAGE,
      loadComponent: () =>
        import("../../admin/components/ai-usage/ai-usage.component").then((m) => m.AiUsageComponent),
      title: "AI Usage"
    },
    {
      path: "**",
      redirectTo: OrganizationRoutesConstants.MY_ORGANIZATION
    }
  ]
};

